module.exports = __webpack_public_path__ + "img/coletiva.23de6d6c.jpg";